import { render, staticRenderFns } from "./selfauditdiolg.vue?vue&type=template&id=4b3c2b9c&scoped=true&"
import script from "./selfauditdiolg.vue?vue&type=script&lang=js&"
export * from "./selfauditdiolg.vue?vue&type=script&lang=js&"
import style0 from "./selfauditdiolg.vue?vue&type=style&index=0&id=4b3c2b9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3c2b9c",
  null
  
)

export default component.exports